/* Receving three(3) parameters
    1. history from useHistory hook
    2. route where page will be redirect
    3. timeout time in milisecond
*/
export function moveToWithTimeout(history, route, timeout = 0) {
    setTimeout(() => {
        history.push(route);
    },timeout);
}

export function goTo(history, route) {
    history.push(route);
}

export function getGikeyValue(data, num) {
    let length = 0;
    let result = '';
    
    let first = 0;
    let last = 1;
    
    let sumBigInt = 0;
    
    for(let i = 0; i < data.length; i++) {
        sumBigInt = (first + last);
        if((sumBigInt % 5 === 0) && length < num) {
            result += data.charAt(i);
            length++;
        }
        const temp = first;
        first = last;
        last = temp + first;
    }
    
    return result;
}